import { render, staticRenderFns } from "./UserCommentsDetails.vue?vue&type=template&id=f46df988&scoped=true&"
import script from "./UserCommentsDetails.vue?vue&type=script&lang=ts&"
export * from "./UserCommentsDetails.vue?vue&type=script&lang=ts&"
import style0 from "./UserCommentsDetails.vue?vue&type=style&index=0&id=f46df988&lang=scss&scoped=true&"
import style1 from "./UserCommentsDetails.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f46df988",
  null
  
)

export default component.exports